// Haydock's Catholic Bible Commentary - book/chapter index
// Original source: https://haydock.quidverum.org

export const OLD_TESTAMENT = [
  { name: "Genesis", chapters: 50 },
  { name: "Exodus", chapters: 40 },
  { name: "Leviticus", chapters: 27 },
  { name: "Numbers", chapters: 36 },
  { name: "Deuteronomy", chapters: 34 },
  { name: "Josue (Joshua)", chapters: 24 },
  { name: "Judges", chapters: 21 },
  { name: "Ruth", chapters: 4 },
  { name: "1 Kings (1 Samuel)", chapters: 31 },
  { name: "2 Kings (2 Samuel)", chapters: 24 },
  { name: "3 Kings (1 Kings)", chapters: 22 },
  { name: "4 Kings (2 Kings)", chapters: 25 },
  { name: "1 Paralipomenon (1 Chronicles)", chapters: 29 },
  { name: "2 Paralipomenon (2 Chronicles)", chapters: 36 },
  { name: "1 Esdras (Ezra)", chapters: 10 },
  { name: "2 Esdras (Nehemiah)", chapters: 13 },
  { name: "Tobias", chapters: 14 },
  { name: "Judith", chapters: 16 },
  { name: "Esther", chapters: 16 },
  { name: "Job", chapters: 42 },
  { name: "Psalms", chapters: 150 },
  { name: "Proverbs", chapters: 31 },
  { name: "Ecclesiastes", chapters: 12 },
  { name: "Canticle of Canticles", chapters: 8 },
  { name: "Wisdom", chapters: 19 },
  { name: "Ecclesiasticus (Sirach)", chapters: 51 },
  { name: "Isaias (Isaiah)", chapters: 66 },
  { name: "Jeremias (Jeremiah)", chapters: 52 },
  { name: "Lamentations", chapters: 5 },
  { name: "Baruch", chapters: 6 },
  { name: "Ezechiel (Ezekiel)", chapters: 48 },
  { name: "Daniel", chapters: 14 },
  { name: "Osee (Hosea)", chapters: 14 },
  { name: "Joel", chapters: 3 },
  { name: "Amos", chapters: 9 },
  { name: "Abdias (Obadiah)", chapters: 1 },
  { name: "Jonas (Jonah)", chapters: 4 },
  { name: "Micheas (Micah)", chapters: 7 },
  { name: "Nahum", chapters: 3 },
  { name: "Habacuc (Habakkuk)", chapters: 3 },
  { name: "Sophonias (Zephaniah)", chapters: 3 },
  { name: "Aggeus (Haggai)", chapters: 2 },
  { name: "Zacharias (Zechariah)", chapters: 14 },
  { name: "Malachias (Malachi)", chapters: 4 },
  { name: "1 Machabees", chapters: 16 },
  { name: "2 Machabees", chapters: 15 },
];

export const NEW_TESTAMENT = [
  { name: "St. Matthew", chapters: 28, hasSample: true, sampleSlug: "matthew-1" },
  { name: "St. Mark", chapters: 16 },
  { name: "St. Luke", chapters: 24 },
  { name: "St. John", chapters: 21 },
  { name: "Acts of the Apostles", chapters: 28 },
  { name: "Romans", chapters: 16 },
  { name: "1 Corinthians", chapters: 16 },
  { name: "2 Corinthians", chapters: 13 },
  { name: "Galatians", chapters: 6 },
  { name: "Ephesians", chapters: 6 },
  { name: "Philippians", chapters: 4 },
  { name: "Colossians", chapters: 4 },
  { name: "1 Thessalonians", chapters: 5 },
  { name: "2 Thessalonians", chapters: 3 },
  { name: "1 Timothy", chapters: 6 },
  { name: "2 Timothy", chapters: 4 },
  { name: "Titus", chapters: 3 },
  { name: "Philemon", chapters: 1 },
  { name: "Hebrews", chapters: 13 },
  { name: "James", chapters: 5 },
  { name: "1 Peter", chapters: 5 },
  { name: "2 Peter", chapters: 3 },
  { name: "1 John", chapters: 5 },
  { name: "2 John", chapters: 1 },
  { name: "3 John", chapters: 1 },
  { name: "Jude", chapters: 1 },
  { name: "Apocalypse (Revelation)", chapters: 22 },
];

export const slugify = (name) =>
  name
    .toLowerCase()
    .replace(/\([^)]*\)/g, "")
    .trim()
    .replace(/\s+/g, "-");
